import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=5b097ecc&scoped=true&"
import script from "./WarningModal.vue?vue&type=script&lang=js&"
export * from "./WarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b097ecc",
  null
  
)

export default component.exports